import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  collection,
  addDoc,
  serverTimestamp
} from 'firebase/firestore'
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage'
import {
  useApiRequest,
  useError,
  useForm
} from '../../hooks'

import { db, storage } from '../../firebase'
import TextField from '../Form/TextField'
import DropdownField from '../Form/DropdownField'
import FileField from '../Form/FileField'
import Button from '../Button'
import ProgressBar from '../ProgressBar'
import ContextMenu from '../ContextMenu'
import Columns from '../Columns'
import Spinner from '../Spinner'

export default function ({ siteId }) {
  const navigate = useNavigate()
  const [site] = useApiRequest(`sites/${siteId}`, null)
  const [uploadProgress, setUploadProgress] = useState(null)
  const [loading, setLoading] = useState(false)
  const setError = useError()

  const [getFieldProps, formData, formError] = useForm()

  if (!site) return <Spinner />

  async function handleSubmit(e) {
    e.preventDefault()

    const { name, type, file } = formData

    if (!file) {
      formError({ file: 'Please select a file.' })
      return
    }

    setLoading(true)

    try {
      // Firebase Storage upload
      const fileRef = ref(storage, `stage/site-files/${siteId}/${Date.now()}_${file.name}`)
      const uploadTask = uploadBytesResumable(fileRef, file)

      await new Promise((resolve, reject) => {
        uploadTask.on(
          'state_changed',
          (snapshot) => {
            setUploadProgress(snapshot.bytesTransferred / snapshot.totalBytes)
          },
          reject,
          resolve
        )
      })

      const fileURL = await getDownloadURL(fileRef)

      // Save metadata to Firestore
      await addDoc(collection(db, 'sites', siteId, 'info'), {
        name,
        type,
        createdAt: new Date().toISOString(),
        resource: {
          fileURL,
          mimeType: file.type,
          sha256: null // or compute hash if needed later
        }
      })

      navigate(`/sites/${siteId}`)
    } catch (err) {
      console.error('Upload failed:', err)
      setLoading(false)
      setError(err)
    }
  }

  return (
    <div className='box'>
      <form onSubmit={handleSubmit}>
        <Columns slice={2}>
          <TextField label='Site' value={site.name.stringValue} readOnly={true} />
          <TextField
            label='Name'
            name='name'
            placeholder='Name'
            required={true}
            {...getFieldProps()}
          />
          <DropdownField
            label='Type'
            name='type'
            required={true}
            {...getFieldProps()}>
            <option />
            <option value='floorplan'>Floorplan</option>
            <option value='other'>Other</option>
          </DropdownField>
          <FileField label='File' name='file' {...getFieldProps()} />
        </Columns>
        {uploadProgress && (
          <ProgressBar
            value={uploadProgress}
            className='is-info'
            style={{ marginTop: '2em' }}
          />
        )}
        <div className='flex justify-end'>
          <Button
            type='submit'
            className={loading ? 'is-loading' : ''}
            enabled={`${!loading}`}>
            Create
          </Button>
        </div>
      </form>
    </div>
  )
}
